import { createSelector, createSlice } from "@reduxjs/toolkit";
import * as baseLayerBurnResolvers from "domain/baseLayerBurnResolvers";
import * as persistenceActionTypes from "store/actions/persistence/persistenceActionTypes";

const initialState = {};

const baseLayerBurnSlice = createSlice({
  name: "baseLayerBurn",
  initialState,
  reducers: {
    setBaseLayerBurn: (state, action) => {
      const values = action?.payload ?? {};
      if (values?.constructor?.name !== "Object") {
        return;
      }
      return {
        ...initialState,
        ...values,
      };
    },
    updateBaseLayerBurn: (state, action) => {
      const values = action?.payload;
      if (values?.constructor?.name !== "Object") {
        return;
      }
      return {
        ...state,
        ...values,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      persistenceActionTypes.LOAD_SUBMISSION_SUCCEEDED,
      (_, action) => action?.payload?.data?.state?.baseLayerBurn ?? initialState
    );
  },
});

export const selectBaseLayerBurnInput = (state) => state?.baseLayerBurn ?? null;

export const selectBaseLayerBurn = createSelector(
  [selectBaseLayerBurnInput],
  (baseLayerBurnInput) =>
    baseLayerBurnResolvers.resolveBaseLayerBurn(baseLayerBurnInput)
);

export const {
  setBaseLayerBurn: set,
  updateBaseLayerBurn: update,
} = baseLayerBurnSlice.actions;

export default baseLayerBurnSlice;
